import { Investment } from "./types";

export const SAVE_SHARES_INFO_ACTION = "saveSharesInfo";

interface SaveSharesInfo {
  type: typeof SAVE_SHARES_INFO_ACTION;
  payload: {
    currentShare: Investment;
  };
}

export type Action = SaveSharesInfo;
